/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import _indexOf from 'lodash/indexOf';
import {
  Tile, TileText, TileContent, Button, useBreakpoint, Badge
} from '@one-thd/sui-atomic-components';
import { useDigitalDataStore } from '../../store';
import { Draggable } from '../../components/Draggable';
import logNewRelicCustom from '../../utils/logNewRelicCustom';
import ChoicePrice from './components/ChoicePrice';
import QuantityStepper from './components/QuantityStepper';
import ChoiceImage from './components/ChoiceImage';
import { choiceDefaultProps, choiceProps } from './_types';
import { ACTIVE_GHOST_BTN_OVERRIDE, INACTIVE_GHOST_BTN_OVERRIDE } from './_styles';
import { NEW_RELIC_EVENTS } from '../../constants';

const Accessory = ({
  choice: {
    id,
    mediaUrl,
    shortLabel,
    sku,
    inExcludedShipState,
    promoType,
    // disabled,
    isAvailable
  },
  quickViewHandler,
  choiceMetaData,
  product
}) => {
  const trackQuickViewModalLoadEvent = useDigitalDataStore((state) => state.trackQuickViewModalLoadEvent);

  const matches = useBreakpoint('lg');
  const isDesktop = matches.greater;

  const onClickQuickView = (itemId) => {
    trackQuickViewModalLoadEvent();
    quickViewHandler({ itemId });
    logNewRelicCustom(NEW_RELIC_EVENTS.QUICK_VIEW, { itemId });
  };

  const getStyle = (style) => {
    return isDesktop ? style.desktop : style.mobile;
  };

  const tileStyle = {
    desktop: {
      height: 250,
      // width: 150,
      alignItems: 'flex-start',
      border: '2px solid #ccc',
      borderRadius: '3px 3px 0px 0px',
      outline: 'none'
    },
    mobile: {
      height: 205,
      // width: 120,
      alignItems: 'flex-start',
      border: '2px solid #ccc',
      borderRadius: '3px 3px 0px 0px',
      outline: 'none'
    }
  };

  const responsiveTileStyle = getStyle(tileStyle);

  const buttonStyle = {
    desktop: {
      color: !product ? '#ccc' : '#3E7697',
      border: '2px solid #ccc',
      borderTop: 'none',
      height: 44,
      width: '100%',
      borderRadius: '0px 0px 3px 3px'
    },
    mobile: {
      color: '#3E7697',
      border: '2px solid #ccc',
      borderTop: 'none',
      height: 30,
      width: '100%',
      borderRadius: '0px 0px 3px 3px'
    }
  };

  const responsiveButtonStyle = getStyle(buttonStyle);

  const tilePaddingStyle = {
    desktop: {
      paddingTop: 7
    },
    mobile: {
      marginBottom: 6,
      marginTop: 6
    }
  };

  const responsiveTilePaddingStyle = getStyle(tilePaddingStyle);

  const allDisabled = !product?.pricing?.value || !isAvailable;

  const graphMediaUrl = product?.media?.images?.[0]?.url.replace('<SIZE>', 300) || mediaUrl;

  return id && (
    <>
      <div className="sui-flex sui-flex-col-reverse md:sui-flex-col choice--accessory">
        <div
          className="sui-flex sui-flex-col choice"
          role="button"
          tabIndex={0}
          data-choice-id={id}
          data-sku={sku}
          data-grid-span={choiceMetaData?.GridSpan}
        >
          <Tile
            component="div"
            value={sku}
            style={responsiveTileStyle}
            aria-label={`choice ${shortLabel}`}
            disabled={allDisabled}
            onClick={() => null}
          >
            <TileContent
              style={{ alignSelf: 'stretch', justifyContent: 'space-between', width: '100%' }}
              orientation="vertical"
              alignItems="start"
            >
              <div className="sui-flex sui-items-center sui-flex-col sui-self-center sui-h-[65px] md:sui-h-[100px]">
                {product?.fulfillment && (
                  <>
                    {(!isAvailable && !inExcludedShipState) && (
                      <span className="sui-absolute custom-badge">
                        <Badge size="small" variant="regular" color="danger">Out of Stock</Badge>
                      </span>
                    )}
                    {(!isAvailable && inExcludedShipState) && (
                      <span className="sui-absolute custom-badge">
                        <Badge size="small" variant="regular" color="danger">Unavailable</Badge>
                      </span>
                    )}
                  </>
                )}
                <Draggable isVisualizerDrag={false} id={id} choiceId={id}>
                  <ChoiceImage
                    disabled={allDisabled}
                    mediaUrl={graphMediaUrl}
                  />
                </Draggable>
              </div>
              <TileText align="left" lineClamp="3" height="normal" style={{ maxHeight: '6rem' }}>{shortLabel}</TileText>
              <ChoicePrice
                graphProduct={product}
                promoType={promoType}
                sku={sku}
              />
            </TileContent>
          </Tile>
          <Button
            style={responsiveButtonStyle}
            className={!product ? INACTIVE_GHOST_BTN_OVERRIDE : ACTIVE_GHOST_BTN_OVERRIDE}
            onClick={
              !product
                ? () => null
                : () => onClickQuickView(sku)
            }
            variant="ghost"
            value={id}
            disabled={!product}
          >
            Quick View
          </Button>
        </div>
        <div>
          <QuantityStepper
            sku={sku}
            choiceMetaData={choiceMetaData}
            isAvailable={isAvailable}
            id={id}
            responsiveTilePaddingStyle={responsiveTilePaddingStyle}
            disabled={allDisabled}
          />
        </div>
      </div>
    </>
  );
};

Accessory.propTypes = choiceProps;

Accessory.defaultProps = choiceDefaultProps;

export default Accessory;
